/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> (and
// <%= stylesheet_pack_tag 'hello_vue' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

// import Vue from 'vue'
// import App from '../App.vue'

// document.addEventListener('DOMContentLoaded', () => {
//   const el = document.body.appendChild(document.createElement('hello'))
//   const app = new Vue({
//     el,
//     render: h => h(App)
//   })

//   console.log(app)
// })

import Vue from "vue";
import VueI18n from 'vue-i18n'
import App from "../App.vue";
import router from "../router";
import store from "../store";
import moment from 'moment';
import VCalendar from 'v-calendar';
import VueTextareaAutosize from 'vue-textarea-autosize'
import VueFuse from 'vue-fuse'
import VueFriendlyIframe from 'vue-friendly-iframe';


Vue.use(VueTextareaAutosize)
Vue.use(VueFuse)
Vue.use(VueI18n)
Vue.use(VueFriendlyIframe)

Vue.use(require('vue-moment'));
Vue.filter('formatDateTime', function(value) {
  if(value){
    if(moment(String(value)).format('YYYY') == moment(new Date()).format('YYYY')){
      return moment(String(value)).format('MMM Do [at] h:mm a');
    } else {
      return moment(String(value)).format('MMM Do YYYY [at] h:mm a');
    }
  }
});

Vue.filter('formatDate', function(value) {
  if(value){
    if(moment(String(value)).format('YYYY') == moment(new Date()).format('YYYY')){
      return moment(String(value)).format('MMM Do');
    } else {
      return moment(String(value)).format('MMM Do YYYY');
    }
  }
});

Vue.filter('formatDateLong', function(value) {
  if(value){
    return moment(String(value)).format('MMMM Do YYYY');
  }
});

Vue.use(VCalendar, {
  componentPrefix: 'vc'
});

Vue.mixin({
  methods: {
    generateTelLinks(text) {
      var phone_regex = /(\d?-?\(?\d{3}\)? ?-?\d{3}-?\d{4})/g;
      return text.replace(phone_regex, "<a class='do-not-collapse' v-on:click.stop='focus' href='tel:$1'>$1</a>");
    }
  }
})

// Vue.config.productionTip = false;

window.store = store;

import en from "../locales/en.json";

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: { en }, // set locale messages
})

const app_root_element = document.getElementById('todo-app');

new Vue({
  i18n,
  router,
  store,
  render: h => h(App, {
    props: {
      gmail: app_root_element.dataset.gmail,
    }
  })
}).$mount("#todo-app");




// The above code uses Vue without the compiler, which means you cannot
// use Vue to target elements in your existing html templates. You would
// need to always use single file components.
// To be able to target elements in your existing html/erb templates,
// comment out the above code and uncomment the below
// Add <%= javascript_pack_tag 'hello_vue' %> to your layout
// Then add this markup to your html template:
//
// <div id='hello'>
//   {{message}}
//   <app></app>
// </div>


// import Vue from 'vue/dist/vue.esm'
// import App from '../app.vue'
//
// document.addEventListener('DOMContentLoaded', () => {
//   const app = new Vue({
//     el: '#hello',
//     data: {
//       message: "Can you say hello?"
//     },
//     components: { App }
//   })
// })
//
//
//
// If the using turbolinks, install 'vue-turbolinks':
//
// yarn add 'vue-turbolinks'
//
// Then uncomment the code block below:
//
// import TurbolinksAdapter from 'vue-turbolinks'
// import Vue from 'vue/dist/vue.esm'
// import App from '../app.vue'
//
// Vue.use(TurbolinksAdapter)
//
// document.addEventListener('turbolinks:load', () => {
//   const app = new Vue({
//     el: '#hello',
//     data: {
//       message: "Can you say hello?"
//     },
//     components: { App }
//   })
// })
